<template>
    <div>
      <div style="text-align:center;width:100%;padding:10px;font-size:28px;font-weight:300;">
        {{greetText}}, {{userInfo.name.split(' ')[0]}}
      </div>
      <v-layout wrap>
        <v-flex
          md6
          style="padding:20px"
        >
          <v-card>
            <v-toolbar
              dense
              flat
              dark
              color="#212121"
            >
              <v-icon
                style="padding-right: 10px;"
                color="#81D4FA"
              >
                mdi-shimmer
              </v-icon>
              <div
                style="font-weight: 900;"
              >
                New Features in {{ app_name }}
              </div>
              <v-spacer />
              <div>v{{ version }}</div>
            </v-toolbar>
            <v-card-text>
              <div>
                <div
                  v-for="note in getFeaturedReleaseNotes()"
                  :key="note.title"
                  style="display:flex;margin-bottom: 10px;"
                >
                    <v-icon
                    left
                    class="elevation-1"
                    dark
                    :style="`background: ${note.color};padding:10px;border-radius: 50%;align-self: flex-start;`"
                  >
                    {{ note.icon }}
                  </v-icon>
                  <div>
                    <div
                      style="font-size: 18px;font-weight:700;"
                    >
                      {{ note.title }}
                    </div>
                    <div>
                      {{ note.feature_desc }}
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions
              style="background: rgba(0,0,0,0.05);"
            >
              <v-spacer />
              <v-btn
                @click="showFullChangelog = true"
                flat
                small
              >
                View Full Changelog
                <v-icon right dark small>mdi-arrow-right-drop-circle</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex
          md6
          style="padding:20px"
        >
          <v-card>
            <v-card-title
              style="border-bottom:1px lightblue solid;"
            >
              Recently Viewed
            </v-card-title>
            <v-card-text
              style="padding:0;"
            >
              <v-list>
                <div
                  v-for="item in lastViewedObjects"
                  :key="`${item.type}-${item.id}`"
                >
                  <v-list-tile
                    avatar
                    @click="$router.push({ name: item.type && item.type == 'form' ? 'UserForm' : 'Contact', params: { id: item.id } })"
                  >
                    <v-list-tile-action>
                      <v-icon>
                        {{ item.type == "form" ? 'assignment' : 'person'}}
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content
                      v-if="item.type == 'form'"
                    >
                      <v-list-tile-title>{{item.party_name}} | {{item.form_number}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.name}}
                        <span
                          v-if="item.tags.length > 0"
                          style="padding-left:20px;"
                        >
                          <span
                            v-for="tag in item.tags"
                            class="inline-tag"
                          >
                            {{tag}}
                          </span>
                        </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content
                      v-if="item.type == 'contact'"
                    >
                      <v-list-tile-title>{{item.full_name}} | {{item.cuid}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          v-if="item.tags.length > 0"
                        >
                          <span
                            v-for="tag in item.tags"
                            class="inline-tag"
                          >
                            {{tag}}
                          </span>
                        </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="showFullChangelog"
        width="600"
      >
        <v-card>
          <ChangeLog
            v-if="showFullChangelog"
            :version="version"
            @close="showFullChangelog = false"
          />
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import ChangeLog from '@/components/global/ChangeLog'
import GlobalConstants from '@/globals'

export default {
  name: 'AppHome',
  props: ['version'],
  components: {
    ChangeLog,
  },
  created () {
    this.documentTitle('Home')
  },
  data () {
    return {
      lastViewedObjects: JSON.parse(localStorage.getItem('user-last-viewed:' + this.$store.state.auth.id)),
      showFullChangelog: false,
      releaseNotes: GlobalConstants.ReleaseNotes,
    }
  },
  computed: {
    greetText () {
      var hr = (new Date()).getHours()
      switch (true) {
        case (hr < 12):
          return 'Good Morning'
          break
        case (hr < 17):
          return 'Good Afternoon'
          break
        case (hr < 20):
          return 'Good Evening'
          break
        default:
          return 'Hello'
          break
      }
    }
  },
  methods: {
    getCurrentReleaseNotes () {
      return this.releaseNotes.find(r => r.version === this.version) || { version: this.version, features: [{title: 'No Release Notes', feature: true, feature_desc: "No Release Notes"}], bugfixes: [] }
    },
    getFeaturedReleaseNotes () {
      var tmpNotes = []
      var tmpCurrentReleaseNotes = this.getCurrentReleaseNotes()
      tmpCurrentReleaseNotes.features.forEach(r => {
        if (r.feature) {
          tmpNotes.push(r)
        }
      })
      tmpCurrentReleaseNotes.bugfixes.forEach(r => {
        if (r.feature) {
          tmpNotes.push(r)
        }
      })
      return tmpNotes
    }
  },
}
</script>

<style>

.inline-tag {
  display:inline-block;
  font-weight: bold;
  background-color:lightgrey;
  color:white;
  border-radius:3px;
  padding:3px 4px 2px 4px;
  text-align:center;
  margin-right:5px;
  line-height:12px;
}

</style>
